import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { AlertCircle, Inbox, RefreshCw } from "lucide-react";

interface StatePanelProps {
  kind: "loading" | "empty" | "error";
  title?: string;
  description?: string;
  onRetry?: () => void;
}

export function StatePanel({ kind, title, description, onRetry }: StatePanelProps) {
  if (kind === "loading") {
    return <Stack className="state-panel state-panel-loading mui-state-panel" role="status" aria-label={title ?? "正在加载"} spacing={1.25}><Box className="pixel-loader" aria-hidden="true">{Array.from({ length: 9 }, (_, index) => <span key={index} />)}</Box><Typography component="h2" variant="subtitle2">{title ?? "正在整理内容"}</Typography><Typography color="text.secondary" variant="body2">请稍候，马上就好</Typography></Stack>;
  }

  if (kind === "error") {
    return <Alert className="state-panel state-panel-error mui-state-panel" severity="error" icon={<AlertCircle aria-hidden="true" />} action={onRetry ? <Button color="inherit" size="small" startIcon={<RefreshCw aria-hidden="true" />} onClick={onRetry}>重新加载</Button> : undefined}><Typography component="h2" variant="subtitle2">{title ?? "加载失败"}</Typography>{description ? <Typography variant="body2">{description}</Typography> : null}</Alert>;
  }

  return (
    <Box className="state-panel state-panel-empty mui-state-panel" role="status">
      <Inbox aria-hidden="true" />
      <Typography component="h2" variant="h6">{title ?? "暂时没有内容"}</Typography>
      {description ? <Typography color="text.secondary">{description}</Typography> : null}
      {onRetry ? <Button variant="outlined" startIcon={<RefreshCw aria-hidden="true" />} onClick={onRetry}>重新加载</Button> : null}
    </Box>
  );
}
